import React, { useState, useEffect, useCallback } from 'react';
import TopMenu from '../components/TopMenu';
import { userService } from '../_services/user.service';
import WholesalerDashboard from '../components/Wholesaler/Dashboard';
import DistributorDashboard from '../components/Distributor/Dashboard';
import AdminDashboard from '../components/Admin/Dashboard';
import SubAdminDashboard from '../components/SubAdmin/Dashboard';
import BrokerDashboard from '../components/Broker/Dashboard';
import { safeParseDate } from '@/lib/utils';
import { format } from 'date-fns';

function Dashboard() {
    // Calculate default dates
    const getDefaultDates = () => {
        const defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 30);
        const defaultEndDate = new Date();
        return { defaultStartDate, defaultEndDate };
    };

    // Get stored dates from localStorage
    const getStoredDates = () => {
        const { defaultStartDate, defaultEndDate } = getDefaultDates();
        const storedStartDate = localStorage.getItem('User_Start_Date');
        const storedEndDate = localStorage.getItem('User_End_Date');
        
        const startdate = (storedStartDate && storedStartDate !== "" && storedStartDate !== "null")
            ? safeParseDate(storedStartDate, defaultStartDate)
            : defaultStartDate;
        const enddate = (storedEndDate && storedEndDate !== "" && storedEndDate !== "null")
            ? safeParseDate(storedEndDate, defaultEndDate)
            : defaultEndDate;
        
        return { startdate, enddate };
    };

    // Get initial user data
    const getInitialUserData = () => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            if (!user) {
                if (!userService.isSessionEndedHoldActive()) {
                    userService.logout();
                }
                return null;
            }
            return user;
        } catch (e) {
            if (!userService.isSessionEndedHoldActive()) {
                userService.logout();
            }
            return null;
        }
    };

    // Initialize state
    const { startdate, enddate } = getStoredDates();
    const initialUserData = getInitialUserData();

    const [state, setState] = useState({
        dashboardListRendered: false,
        dashboardName: initialUserData?.dList?.[0]?.dashboardName || '',
        startDate: startdate,
        endDate: enddate,
        DisshowPopup: false,
        SubDisshowPopup: false,
        userdata: initialUserData,
        AllDirectOverride: '',
        dist_usertype: 'N/A',
        filterUpdateTrigger: 0
    });

    // Handle dashboard list rendered callback
    const dashboardListRendered = useCallback((e) => {
        try {
            setState(prev => ({
                ...prev,
                dashboardListRendered: true,
                dashboardName: e
            }));
        } catch (error) { }
    }, []);

    // Handle filter change
    const handeChangefilter = useCallback((e) => {
        setState(prev => ({
            ...prev,
            userdata: JSON.parse(localStorage.getItem('user')),
            filterUpdateTrigger: prev.filterUpdateTrigger + 1
        }));
    }, []);

    // Handle date change
    const handleChangeStartEnd = useCallback((d) => {
        try {
            const [start, end] = d.split('-');
            setState(prev => ({
                ...prev,
                startDate: start,
                endDate: end
            }));
        } catch (error) { }
    }, []);

    // Handle All/Direct/Override change
    const handleChangeAllDirectOverride = useCallback((e) => {
        try {
            setState(prev => ({
                ...prev,
                userdata: JSON.parse(localStorage.getItem('user')),
                dist_usertype: e
            }));
        } catch (error) { }
    }, []);

    // Handle All/Direct Override user
    const handleAllDirectOverride_user = useCallback((e) => {
        try {
            setState(prev => ({
                ...prev,
                AllDirectOverride: e,
                dist_usertype: e
            }));
        } catch (error) { }
    }, []);

    // Handle dashboard name change
    const handleChange = useCallback((e) => {
        setState(prev => ({
            ...prev,
            dashboardName: e
        }));
    }, []);

    // Initialize on mount
    useEffect(() => {
        // Load user data
        const user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            setState(prev => ({ ...prev, userdata: user }));
            userService.getUser(user.id, user.authdata).then(users => {
                // Update if needed
            });
        }
    }, []);

    // Render dashboard based on user role
    const RenderDashboard = () => {
        if (!state.dashboardListRendered || !state.userdata) {
            return null;
        }

        const dashboardProps = {
            dist_usertype: state.dist_usertype,
            dashboardName: state.userdata?.dList?.[0]?.dashboardName || state.dashboardName,
            handeChangefilter: handeChangefilter,
            handleAllDirectOverride_user: handleAllDirectOverride_user,
            startDate: state.startDate,
            endDate: state.endDate
        };

        try {
            if (state.userdata.userrole === "Wholesaler") {
                return <WholesalerDashboard {...dashboardProps} filterUpdateTrigger={state.filterUpdateTrigger} />;
            } else if (state.userdata.isBrokerTypeUser === true) {
                return (
                    <BrokerDashboard 
                        {...dashboardProps}
                        Wholesaler={state.userdata.wholesaler}
                        DisEmail={state.userdata.email}
                        DisName={state.userdata.userName}
                        filterUpdateTrigger={state.filterUpdateTrigger}
                    />
                );
            } else if (state.userdata.userrole === "Distributor") {
                return (
                    <DistributorDashboard 
                        {...dashboardProps}
                        Wholesaler={state.userdata.wholesaler}
                        DisEmail={state.userdata.email}
                        DisName={state.userdata.userName}
                        filterUpdateTrigger={state.filterUpdateTrigger}
                    />
                );
            } else if (state.userdata.userrole === "SubAdmin") {
                return <SubAdminDashboard dashboardName={dashboardProps.dashboardName} handeChangefilter={handeChangefilter} startDate={state.startDate} endDate={state.endDate} filterUpdateTrigger={state.filterUpdateTrigger} />;
            } else {
                return <AdminDashboard dashboardName={dashboardProps.dashboardName} handeChangefilter={handeChangefilter} startDate={state.startDate} endDate={state.endDate} filterUpdateTrigger={state.filterUpdateTrigger} />;
            }
        } catch (error) {
            // Fallback rendering
            if (state.userdata.userrole === "Wholesaler") {
                return <WholesalerDashboard dashboardName={state.userdata?.paramsname} handeChangefilter={handeChangefilter} startDate={state.startDate} endDate={state.endDate} filterUpdateTrigger={state.filterUpdateTrigger} />;
            } else if (state.userdata.isBrokerTypeUser === true) {
                return <BrokerDashboard {...dashboardProps} Wholesaler={state.userdata?.wholesaler} DisEmail={state.userdata?.email} DisName={state.userdata?.paramsname} filterUpdateTrigger={state.filterUpdateTrigger} />;
            } else if (state.userdata.userrole === "Distributor") {
                return <DistributorDashboard {...dashboardProps} Wholesaler={state.userdata?.wholesaler} DisEmail={state.userdata?.email} DisName={state.userdata?.paramsname} filterUpdateTrigger={state.filterUpdateTrigger} />;
            } else if (state.userdata.userrole === "SubAdmin") {
                return <SubAdminDashboard dashboardName={state.userdata?.paramsname} handeChangefilter={handeChangefilter} startDate={state.startDate} endDate={state.endDate} filterUpdateTrigger={state.filterUpdateTrigger} />;
            } else {
                return <AdminDashboard dashboardName={state.userdata?.paramsname} handeChangefilter={handeChangefilter} startDate={state.startDate} endDate={state.endDate} filterUpdateTrigger={state.filterUpdateTrigger} />;
            }
        }
    };

    return (
        <div>
            <h2 className="text-2xl font-semibold mb-4">Dashboard</h2>
            
            <TopMenu 
                dashboardListRendered={dashboardListRendered} 
                handleChange={handleChange} 
                handleChangeDateNew={handleChangeStartEnd} 
                handeChangefilter={handeChangefilter} 
                dashboardTitle={state.dashboardTitle} 
                startDate={state.startDate} 
                endDate={state.endDate} 
                handleChangeAllDirectOverride={handleChangeAllDirectOverride} 
            />

            {state.dashboardListRendered && <RenderDashboard />}
        </div>
    );
}

export default Dashboard;
